import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllStockOpname(date, rackId) {
    try {
        let res = await client.get(`/stock-opname?date=${date}&rack_id=${rackId}`);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllStockOpname,
};
